import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, TopInfoWrapper, ExtraSpecsWrapper, ExtraSpecItem } from './styles'
import { InfoBlock } from '../../../../../components'
import { timeConverterMMDDYYHHMM } from '../../../../../utils/dates'

type OverviewProps = {
  volumeType: any
}

const Overview: FC<OverviewProps> = ({ volumeType }) => {
  const [t] = useTranslation()

  const specifications = [
    {
      title: t("ID"),
      id: '1',
      value: volumeType.id
    },
    {
      title: t("NAME"),
      id: '2',
      value: volumeType.name || 'N/A'
    },
    {
      title: t("DESCRIPTION"),
      id: '3',
      value: volumeType.description || 'N/A'
    },
    {
      title: t("IS_PUBLIC"),
      id: '4',
      value: volumeType.is_public ? t("YES") : t("NO")
    },
    {
      title: t("REGION"),
      id: '5',
      value: volumeType.region || 'N/A'
    },
    {
      title: t("CREATED_AT"),
      id: '6',
      value: volumeType.created_at ? timeConverterMMDDYYHHMM(volumeType.created_at) : 'N/A'
    },
    {
      title: t("UPDATED_AT"),
      id: '7',
      value: volumeType.updated_at ? timeConverterMMDDYYHHMM(volumeType.updated_at) : 'N/A'
    },
  ]

  const extraSpecs = volumeType?.extra_specs ? Object.entries(volumeType.extra_specs) : []

  return (
    <Container>
      <TopInfoWrapper>
        <InfoBlock
          data={specifications}
          title={t("VOLUME_TYPE_SPECIFICATIONS")}
          customStyles={{ marginTop: '10px', width: "545px", flex: 'auto 1', marginRight: '10px' }}
        />
      </TopInfoWrapper>
      {extraSpecs.length > 0 && (
        <ExtraSpecsWrapper>
          <h3>{t("EXTRA_SPECS")}</h3>
          {extraSpecs.map(([key, value]: [string, any], index) => (
            <ExtraSpecItem key={index}>
              <span className="key">{key}:</span>
              <span className="value">{value}</span>
            </ExtraSpecItem>
          ))}
        </ExtraSpecsWrapper>
      )}
    </Container>
  )
}

export default Overview
